<template>
  <div class="banner-popup__container">
    <div class="banner-popup__box" v-if="visible && detailsInfo && detailsInfo.status == 1">
      <!-- head -->
      <div class="banner-popup__head">
        <h3 class="banner-popup__title">
          <span>{{ detailsInfo && detailsInfo[`${currentLang.prefix}cate_name`] ? detailsInfo[`${currentLang.prefix}cate_name`] : homePageLang.bannerPopup.title }}</span>
        </h3>
        <div class="banner-popup__close" @click="onClose">
          <i class="el-icon-error"></i>
        </div>
      </div>
      <div class="banner-popup__link-box">
        <div class="banner-popup__link" @click="onGoLink">
          <span>{{ homePageLang.bannerPopup.linkText }}</span>
          <i class="el-icon-d-arrow-right"></i>
        </div>
      </div>
      <!-- body -->
      <div class="banner-popup__body">
        <img :src="detailsInfo.full_image" class="banner-popup__img" v-if="detailsInfo && detailsInfo.full_image" />
        <div
          class="banner-popup__content"
          v-html="$convertPxToRem(detailsInfo[`${currentLang.prefix}content`])"
          v-if="detailsInfo && detailsInfo[`${currentLang.prefix}content`]"
        ></div>
      </div>
    </div>
  </div>
</template>

<script>
import { storage_key } from '@/config/constant'
import { mapGetters } from "vuex";
import { getCateDetailInfo } from '@/utils/http'


export default {
  data() {
    return {
      detailsInfo: null,
      visible: true,
      expanded: true,
    }
  },

  computed: {
    ...mapGetters(["currentLang"]),
    homePageLang() {
      return this.currentLang.config.homePage;
    },
  },

  created() {
    const popupVisible = window.sessionStorage.getItem(storage_key.indexPopup)
    if (popupVisible != null && popupVisible != undefined) {
      this.visible = JSON.parse(popupVisible)
    }
    this.getDetails()
  },

  mounted() {

  },

  methods: {
    // 关闭悬浮弹框回调
    onClose() {
      this.visible = false
      window.sessionStorage.setItem(storage_key.indexPopup, this.visible)
    },

    // 悬浮弹框折叠展开回调
    onExpand(flag) {
      this.expanded = flag
    },

    onGoLink() {
      if (!this.detailsInfo) return

      const { is_blank, url } = this.detailsInfo
      const target = is_blank == 0 ? "_self" : '_blank'
      window.open(url, target)
    },

    getDetails() {
      getCateDetailInfo({ cate_id: 98 }).then(res => {
        console.log(res);
        if (res.code === 1) {
          this.detailsInfo = res.data;
          console.log('this.detailsInfo', this.detailsInfo)
        }
      });
    },
  }
}
</script>

<style lang="scss" scoped>
* {
  box-sizing: border-box;
  padding: 0;
  margin: 0;
}

.banner-popup__box {
  position: fixed;
  right: 20px;
  bottom: 50px;
  z-index: 100;
  display: flex;
  flex-direction: column;
  width: 320px;
  min-height: 200px;
  max-height: 400px;
  background: #fff;
  border-radius: 10px;
  border: 1px solid var(--main-color);
  // border: 1px solid var(--main-color-blue);
  color: #333;
}

.banner-popup__head {
  border-radius: 8px 8px 0 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 5px 0px 5px 10px;
  background-color: var(--main-color);

  .banner-popup__title {
    font-size: 17px;
    font-weight: 600;
    letter-spacing: 2px;
    color: #fff;
  }

  .banner-popup__close {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 36px;
    height: 100%;
    cursor: pointer;
    color: #fff;
    font-size: 20px;
  }
}

.banner-popup__link-box {
  padding: 8px 10px 5px;
  cursor: pointer;

  .banner-popup__link {
    padding: 2px 8px;
    background-color: rgba($color: #00a4ff, $alpha: 0.15);
    border: 1px solid #00a4ff;
    border-radius: 5px;
    color: #00a4ff;
    font-size: 15px;
    font-weight: normal;
    letter-spacing: 1px;
    text-align: center;
  }
}


.banner-popup__body {
  flex: 1;
  padding: 5px 8px;
  overflow: auto;
  overflow-x: hidden;
  border-radius: 0px 0px 10px 10px;

  .banner-popup__img {
    width: 100%;
  }

  .banner-popup__content {
    font-size: 15px;
    color: #555;
    line-height: 1.8;
    font-weight: normal;
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/index/modules/BannerPopup.vue